<template>
	<widget-settings-layout ref="layout" v-if="settings" slug="topDonation" name="Top Donation" :error="saveError" :saving="saving" :has-unsaved-changes="hasUnsavedChanges" :settings="settings" :saved-settings-json="savedSettingsJson" @save="save">
		<b-card title="Label" class="mb-3">
			<b-form-row>
				<b-col>
					<b-form-group label="Label text">
						<b-form-input v-model="settings.label" placeholder="Top donation:" />
					</b-form-group>
				</b-col>
				<b-col cols="auto" class="d-flex align-items-center pt-2">
					<b-form-checkbox v-model="settings.showLabel">Show label</b-form-checkbox>
				</b-col>
			</b-form-row>
			<b-form-checkbox v-model="settings.hideCurrency">Hide currency symbol</b-form-checkbox>
			<b-form-checkbox v-model="settings.hideAvatar">Hide avatar</b-form-checkbox>
			<p class="text-muted mt-2 mb-0"><small>Shows the highest donation from the last 6 hours. Updates live during stream.</small></p>
		</b-card>
		<text-settings :settings="settings" />
		<b-card title="Outline" class="mb-3">
			<b-form-row>
				<b-col>
					<b-form-group label="Blur radius">
						<b-input-group append="px"><b-form-input type="number" min="0" max="100" step="any" v-model.number="settings.blurRadius" /></b-input-group>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Spread radius">
						<b-input-group append="px"><b-form-input type="number" min="0" max="10" step="any" v-model.number="settings.spreadRadius" /></b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="6">
					<b-form-group label="Outline color"><color-picker v-model="settings.shadowColor" /></b-form-group>
				</b-col>
			</b-form-row>
		</b-card>
		<b-card title="Colors" class="mb-3">
			<b-form-group label="Text color"><color-picker v-model="settings.textColor" /></b-form-group>
		</b-card>
		<b-card title="Layout" class="mb-3">
			<b-form-group label="Vertical align">
				<b-button-group class="d-flex">
					<b-button v-b-tooltip.hover title="Top"    :pressed="settings.verticalAlign === 'top'"    @click="settings.verticalAlign = 'top'"    variant="outline-secondary"><b-icon icon="align-top"    /></b-button>
					<b-button v-b-tooltip.hover title="Middle" :pressed="settings.verticalAlign === 'middle'" @click="settings.verticalAlign = 'middle'" variant="outline-secondary"><b-icon icon="align-middle" /></b-button>
					<b-button v-b-tooltip.hover title="Bottom" :pressed="settings.verticalAlign === 'bottom'" @click="settings.verticalAlign = 'bottom'" variant="outline-secondary"><b-icon icon="align-bottom" /></b-button>
				</b-button-group>
			</b-form-group>
		</b-card>
		<b-card title="Extra CSS" class="mb-3">
			<b-form-group><b-textarea v-model="settings.extraCSS" /></b-form-group>
		</b-card>
		<template #preview>
			<latest-event-widget-preview :settings="settings || {}" sample-name="ExampleUser" :sample-amount="10" />
		</template>
	</widget-settings-layout>
</template>

<script>
import latestEventMixin from './latestEventMixin';
import LatestEventWidgetPreview from '@/components/Widget/LatestEventWidgetPreview.vue';
export default {
	mixins: [ latestEventMixin ],
	components: { LatestEventWidgetPreview },
	data() { return { widgetType: 'top-donation' }; },
};
</script>
